import { PropsWithChildren } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';

export const GenericErrorMessage = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation();
  return (
    <ErrorBoundary fallback={<span>{t('error.generic')}</span>}>
      {children}
    </ErrorBoundary>
  );
};
